import WorkOrderCreated from "./WorkOrderCreated";
import WorkOrderCategory from "./WorkOrderCategory";
import TechnicianWorkOrder from "./TechnicianWorkOrder";
import TopTeamWo from "./TopTeamWo";
import LocationWorkOrder from "./LocationWorkOrder";
import BackLogPriority from "./BackLogPriority";
import BackLogCategory from "./BackLogCategory";
import ZoneWorkOrder from "./ZoneWorkOrder";
import { Card, CardBody, CardHeader } from "../../../components/card/card";
import TopChart from "./TopChart";
import React from "react";
import Moment from "moment/moment";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useEffect, useState } from "react";
import { analytics, team } from "../../../api";
import { DateRange } from "../../../components/DateRange";
import { endOfDay, startOfDay, subMonths } from "date-fns";
import { toast } from "react-toastify";
function Team({ locationId }) {
  const [allWo, setAllWo] = useState([]);
  const [completedWoPerDay, setCompletedWoPerDay] = useState([]);
  const [totalCompletedWo, setTotalCompletedWo] = useState(0);
  const [workOrderCreated, setWorkOrderCreated] = useState([]);
  const [workOrderCategory, setWorkOrderCategory] = useState([]);
  const [technicianWorkOrder, setTechnicianWorkOrder] = useState([]);
  const [locationWorkOrder, setLocationWorkOrder] = useState([]);
  const [zoneWorkOrder, setZoneWorkOrder] = useState([]);
  const [backLogByPriority, setBackLogByPriority] = useState([]);
  const [backLogByCategory, setBackLogByCategory] = useState([]);
  const [completedByTeam, setCompletedByTeam] = useState([]);
  const [teams, setTeams] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState("");

  // change start date to last week
  const [date, setDate] = useState({
    startDate: subMonths(new Date(), 1),
    endDate: new Date(),
  });

  async function getTeam() {
    try {
      const res = await team.list();
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data.length) {
          setTeams(data);
        } else {
          setTeams([]);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  const fetchData = async () => {
    try {
      const res = await analytics.getTeamAnalytics({
        team: selectedTeam,
        location_id: locationId,
        start_date: date.startDate
          ? Moment(date.startDate).format("YYYY-MM-DD")
          : null,
        end_date: date.endDate
          ? Moment(date.endDate).format("YYYY-MM-DD [23:59:59]")
          : null,
      });
      if (res.ok) {
        const body = await res.json();
        const data = body.data;
        // group completed Work Order by Day
        const all = data.all_wo;
        const completedPerDay = [];
        const createdPerDay = [];
        let categoriesWithTotalPerDay = [];
        let completedByTeam = [];
        let completedPerTechnicianPerDay = [];
        let completedPerLocationPerDay = [];
        const completedPerZone = [];
        const backlogByPriority = [];
        const backlogByCategory = [];
        //sort all work order by start_date
        all.sort((a, b) => {
          return new Date(a.start_date) - new Date(b.start_date);
        });
        all.forEach((wo) => {
          // group by category and day
          const category = wo.category?.name || 'No Category';
          const day = Moment(wo.start_date).format("YYYY-MM-DD");
          const foundCategory = categoriesWithTotalPerDay.find(
            (item) => item.category === category
          );
          if (foundCategory) {
            const foundDay = foundCategory.data.find(
              (item) => item.day === day
            );
            foundCategory.count += 1;
            if (foundDay) {
              foundDay.count += 1;
            } else {
              foundCategory.data.push({
                day,
                count: 1,
              });
            }
          } else {
            categoriesWithTotalPerDay.push({
              count: 1,
              category,
              data: [
                {
                  day,
                  count: 1,
                },
              ],
            });
          }
          // completed mean status = "Completed"
          if (wo.status === "Completed") {
            const day = Moment(wo.start_date).format("YYYY-MM-DD");
            const found = completedPerDay.find((item) => item.day === day);
            if (found) {
              found.count += 1;
            } else {
              completedPerDay.push({
                day,
                count: 1,
              });
            }
            // group by technician
            let technician = wo.assigned_to_user?.username;
            if (technician) {
              const foundTechnician = completedPerTechnicianPerDay.find(
                (item) => item.username === technician
              );
              if (foundTechnician) {
                const foundDay = foundTechnician.data.find(
                  (item) => item.day === day
                );
                foundTechnician.count += 1;
                if (foundDay) {
                  foundDay.count += 1;
                } else {
                  foundTechnician.data.push({
                    day,
                    count: 1,
                  });
                }
              } else {
                completedPerTechnicianPerDay.push({
                  count: 1,
                  username: technician,
                  firstname: wo.assigned_to_user?.firstname || technician,
                  lastname: wo.assigned_to_user?.lastname || technician,
                  data: [
                    {
                      day,
                      count: 1,
                    },
                  ],
                });
              }
            }
            let team = wo.team?.team_name;
            if (team) {
              const foundTeam = completedByTeam.find(
                (item) => item.team === team
              );
              if (foundTeam) {
                const foundDay = foundTeam.data.find(
                  (item) => item.day === day
                );
                foundTeam.count += 1;
                if (foundDay) {
                  foundDay.count += 1;
                } else {
                  foundTeam.data.push({
                    day,
                    count: 1,
                  });
                }
              } else {
                completedByTeam.push({
                  count: 1,
                  team,
                  data: [
                    {
                      day,
                      count: 1,
                    },
                  ],
                });
              }
            }



            // group by location
            // location is like tree structure have parent and child, we will get the eldest parent location using     a recursive function
            const getEldestParentLocation = (location) => {
              if (location.parent_location) {
                return getEldestParentLocation(location.parent_location);
              }
              return location;
            };
            let location = getEldestParentLocation(wo.location);

            const foundLocation = completedPerLocationPerDay.find(
              (item) => item.location === location.id
            );
            if (foundLocation) {
              const foundDay = foundLocation.data.find(
                (item) => item.day === day
              );
              foundLocation.count += 1;
              if (foundDay) {
                foundDay.count += 1;
              } else {
                foundLocation.data.push({
                  day,
                  count: 1,
                });
              }
            } else {
              completedPerLocationPerDay.push({
                count: 1,
                location: location.id,
                location_name: location.location_name,
                data: [
                  {
                    day,
                    count: 1,
                  },
                ],
              });
            }

            // Group by parent_location.location_name
            const parentLocation =
              wo.asset?.location?.parent_location?.location_name;
            const foundZone = completedPerZone.find(
              (item) => item.location_name === parentLocation
            );
            if (foundZone) {
              const foundDay = foundZone.data.find((item) => item.day === day);
              foundZone.count += 1;
              if (foundDay) {
                foundDay.count += 1;
              } else {
                foundZone.data.push({
                  day,
                  count: 1,
                });
              }
            } else {
              completedPerZone.push({
                count: 1,
                location_name: parentLocation,
                data: [
                  {
                    day,
                    count: 1,
                  },
                ],
              });
            }
          } else {
            //all work order that not completed are called backlog
            const priority = wo.priority;
            const found = backlogByPriority.find(
              (item) => item.priority === priority
            );
            if (found) {
              found.count += 1;
            } else {
              backlogByPriority.push({
                count: 1,
                priority,
              });
            }
            const category = wo.category?.name || 'No Category';
            const foundCategory = backlogByCategory.find(
              (item) => item.category === category
            );
            if (foundCategory) {
              foundCategory.count += 1;
            } else {
              backlogByCategory.push({
                count: 1,
                category,
              });
            }
          }
          // is for all work order no mather the status
          const found = createdPerDay.find((item) => item.day === day);
          if (found) {
            found.count += 1;
          } else {
            createdPerDay.push({
              day,
              count: 1,
            });
          }
        });
        // sort the data descending by count and only take first 10 data
        completedPerTechnicianPerDay.sort((a, b) => b.count - a.count);
        completedPerTechnicianPerDay = completedPerTechnicianPerDay.slice(0, 10);

        // sort the data descending by count and only take first 10 data
        completedPerLocationPerDay.sort((a, b) => b.count - a.count);
        completedPerLocationPerDay = completedPerLocationPerDay.slice(0, 10);

        completedByTeam.sort((a, b) => b.count - a.count);
        completedByTeam = completedByTeam.slice(0, 10);

        console.log({ completedByTeam });

        setCompletedByTeam(completedByTeam);
        console.log({ createdPerDay });
        setWorkOrderCreated(createdPerDay);
        setZoneWorkOrder(completedPerZone);
        setCompletedWoPerDay(completedPerDay);
        setWorkOrderCategory(categoriesWithTotalPerDay);
        setTechnicianWorkOrder(completedPerTechnicianPerDay);
        setLocationWorkOrder(completedPerLocationPerDay);
        setBackLogByPriority(backlogByPriority);
        setBackLogByCategory(backlogByCategory);

        // Total Completed WOrk order
        const totalCompleted = all.filter(
          (wo) => wo.status === "Completed"
        ).length;
        setTotalCompletedWo(totalCompleted);
        setAllWo(all);
        console.log({
          createdPerDay,
          completedPerDay,
          categoriesWithTotalPerDay,
          completedPerTechnicianPerDay,
          completedPerLocationPerDay,
          backlogByPriority,
          backlogByCategory,
          totalCompleted,
        });
      }
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    getTeam();
  }, []);
  useEffect(() => {
    fetchData();
  }, [date, selectedTeam, locationId]);
  const handleChangeDate = (startDate, endDate) => {
    setDate({
      startDate,
      endDate,
    });
  };

  return (
    <div>
      <div className="row mb-3">
        <div className="col-12 col-md-3">
          <DateRange
            onChange={handleChangeDate}
            startDate={date.startDate}
            endDate={date.endDate}
          />
        </div>
        <div className="col-12 col-md-3">
          <select
            className="form-select border-theme color-amber"
            value={selectedTeam}
            onChange={(e) => {
              setSelectedTeam(e.target.value);
            }}
          >
            <option value="">All Teams</option>
            {teams.map((team) => (
              <option value={team.id}>{team.team_name}</option>
            ))}
          </select>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-6">
          <h4>Work Order Complete Rate</h4>
          <div className="row mb-3">
            <div className="col-6">
              <Card>
                <CardBody>
                  <div style={{ textAlign: "center" }}>
                    <h1>{allWo.length}</h1>
                    <div>Created</div>
                  </div>
                </CardBody>
              </Card>
            </div>
            <div className="col-6">
              <Card>
                <CardBody>
                  <div style={{ textAlign: "center" }}>
                    <h1>{totalCompletedWo}</h1>
                    <div>Completed</div>
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>
          <h4>Work Order By Status</h4>
          <TopChart data={allWo} locationId={locationId || ''} startDate={date.startDate} endDate={date.endDate}></TopChart>
        </div>
        <div className="col-12 col-md-6">
          <h4>Work Order By Category</h4>
          <Card>
            <CardBody>
              <div className="d-flex align-items-center mb-2"></div>
              <div>
                <div className="fs-12px fw-bold mb-2 text-inverse text-opacity-50">
                  Number of Work Order
                </div>
                <div className="chart mb-2" style={{ minHeight: "250px" }}>
                  <WorkOrderCategory
                    dataSource={workOrderCategory}
                  ></WorkOrderCategory>
                </div>
              </div>
            </CardBody>
          </Card>
          <div className="row mt-3">
            {workOrderCategory.map((item, index) => (
              <div className="col">
                <Card>
                  <CardBody>
                    <div style={{ textAlign: "center" }}>
                      <h2>{item.count}</h2>
                      <div>{item.category}</div>
                    </div>
                  </CardBody>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-12 col-md-6 mb-3">
          <h4>Completed Work Orders - Top Technicians</h4>
          <Card>
            <CardBody>
              <div>
                <div className="fs-12px fw-bold mb-2 text-inverse text-opacity-50">
                  Number of Work Order
                </div>
                <div className="chart mb-2" style={{ minHeight: "250px" }}>
                  <TechnicianWorkOrder
                    dataSource={technicianWorkOrder}
                  ></TechnicianWorkOrder>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>

        <div className="col-12 col-md-6 mb-3">
          <h4>Completed Work Orders - Top Team</h4>
          <Card>
            <CardBody>
              <div>
                <div className="fs-12px fw-bold mb-2 text-inverse text-opacity-50">
                  Number of Work Order
                </div>
                <div className="chart mb-2" style={{ minHeight: "250px" }}>
                  <TopTeamWo
                    dataSource={completedByTeam}
                  ></TopTeamWo>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
        <div className="col-12 col-md-12 mb-3">
          <h4>Completed Work Orders - Top Locations</h4>
          <Card>
            <CardBody>
              <div className="d-flex align-items-center mb-2"></div>
              <div>
                <div className="fs-12px fw-bold mb-2 text-inverse text-opacity-50">
                  Number of Work Order
                </div>
                <div className="chart mb-2" style={{ minHeight: "550px" }}>
                  <LocationWorkOrder
                    dataSource={locationWorkOrder}
                  ></LocationWorkOrder>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
        <div className="col-12 col-md-6 mb-3">
          <h4>Completed Work Orders - By Zone</h4>
          <Card>
            <CardBody>
              <div className="d-flex align-items-center mb-2"></div>
              <div>
                <div className="fs-12px fw-bold mb-2 text-inverse text-opacity-50">
                  Number of Work Order
                </div>
                <div className="chart mb-2" style={{ minHeight: "250px" }}>
                  <ZoneWorkOrder dataSource={zoneWorkOrder}></ZoneWorkOrder>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
      <div className="row mt-5">
        <h4>Backlog</h4>
        <div className="col-6">

          <BackLogPriority dataSource={backLogByPriority}></BackLogPriority>
        </div>
        <div className="col-6">
          <BackLogCategory dataSource={backLogByCategory}></BackLogCategory>
        </div>

      </div>
    </div>
  );
}

export default Team;
